// extracted by mini-css-extract-plugin
export var base = "_3k-0";
export var updateBanner = "_3k-1";